export default __webpack_public_path__ + "static/small-business-hero-0000c2cfba36d19de40ece589d50cc35.webp";